module.exports = __webpack_public_path__ + "media/images/icons/credit-card-3b355e9feddddcdd813735a3314ec90d.svg";